import { render, staticRenderFns } from "./EmailDetailModal.vue?vue&type=template&id=78021d46"
import script from "./EmailDetailModal.vue?vue&type=script&lang=js"
export * from "./EmailDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports